<template>
  <div class="daily-content">
    <div class="filter-bar" style="justify-content: flex-start;">
      <div>
        <el-date-picker
          v-model="selectedDate"
          type="date"
          placeholder="选择日期"
          value-format="YYYY-MM-DD"
          size="default"
          style="width: 200px"
          @change="fetchDailyData"
        />
      </div>
    </div>

    <el-table :data="statisticsStore.dailyRef" stripe border style="width: 100%" :cell-style="() => ({ verticalAlign: 'top' })">
      <el-table-column prop="tableSessionId" label="单号" width="200" />
      <el-table-column prop="tableNo" label="桌号" width="80" />
      <el-table-column label="人数" width="80">
        <template #default="{ row }">
          <span>{{ row.customerCnt }}人</span>
        </template>
      </el-table-column>
      <el-table-column label="开台时间" width="160">
        <template #default="{ row }">
          <span>{{ tzDayjs.formatDateTime(row.startTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="结束时间" width="160">
        <template #default="{ row }">
          <span>{{ row.endTime ? tzDayjs.formatDateTime(row.endTime) : ''}}</span>
        </template>
      </el-table-column>
      <el-table-column label="详情" min-width="300">
        <template #default="{ row }">
          <div v-html="row.detailText"></div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import { useStatisticsStore } from '@/stores/admin/statisticsStore'
import tzDayjs from '@/utils/dayjs'

const statisticsStore = useStatisticsStore()
const selectedDate = ref(tzDayjs.getCurrentDate())

const fetchDailyData = async () => {
  if (!selectedDate.value) {
    ElMessage.warning('请选择日期')
    return
  }
  statisticsStore.getDailyRevenue(selectedDate.value)
}

onMounted(() => {
  fetchDailyData()
})
</script>

<style scoped>
.daily-content .filter-bar {
  margin-bottom: 20px;
}
</style>